function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    width: 512,
    height: 512,
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#a87b32"
    },
    cx: 64,
    cy: 64,
    r: 64
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a87b32"
    },
    d: "M115.061,102.578L99.605,64.253c-0.028-0.159-0.08-0.314-0.158-0.468   c-0.073-0.522-0.396-1.032-1.004-1.429L45.462,27.644c-1.38-0.904-2.509-0.294-2.509,1.356v0.512v0.512V99v0.512V100l10.796,27.172   C57.088,127.71,60.51,128,64,128C84.855,128,103.376,118.02,115.061,102.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M42.953,29c0-1.65,1.129-2.26,2.509-1.356l52.981,34.712c1.38,0.904,1.38,2.384,0,3.289   l-52.981,34.711c-1.38,0.904-2.509,0.295-2.509-1.355V29z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoRound);
export default __webpack_public_path__ + "static/media/icon_video_round.d8872ccfc669d0f7a6ac5d3de00cf175.svg";
export { ForwardRef as ReactComponent };